import SearchIcon from '@atlaskit/icon/core/search';
import Textfield from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';
import { messages } from '@databases/intl/messages';
import { getService } from '@databases/service-container';
import React, { forwardRef, useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import styled from 'styled-components';

const SearchFieldContainer = styled.div`
  > div {
    padding-inline: ${token('space.200', '16px')};
    column-gap: ${token('space.150', '12px')};
    border: none;
    border-radius: ${token('radius.large', '8px')} !important;

    position: fixed;
    z-index: 2;
    width: 100%;
    border-bottom: ${token('border.width.focused', '2px')} solid
      ${token('color.border', '#091E4224')};

    :focus-within:not([data-disabled]) {
      border-bottom: ${token('border.width.focused', '2px')} solid
        ${token('color.border', '#091E4224')};
    }
  }
`;

interface FieldTypeSearchProps {
  onChange: (val: string) => void;
  value?: string;
  autoFocus?: boolean;
}

const FieldTypeSearch = forwardRef<HTMLInputElement, FieldTypeSearchProps>(
  function FieldTypeSearch({ onChange, value = '', autoFocus }, inputRef) {
    const handleChange = useCallback(
      (e: React.FormEvent) => {
        onChange((e.target as HTMLInputElement).value);
      },
      [onChange]
    );

    const selectionsActions = getService('SelectionsActions');
    const { formatMessage } = useIntl();
    useEffect(() => {
      selectionsActions.deselectAll();
    }, [selectionsActions]);

    return (
      <SearchFieldContainer>
        <Textfield
          testId="field-type-dropdown-search-input"
          ref={inputRef}
          autoComplete="off"
          autoFocus={autoFocus}
          elemBeforeInput={<SearchIcon label="" />}
          placeholder={formatMessage(messages['field-type.search-text'])}
          onChange={handleChange}
          value={value}
          aria-label={formatMessage(messages['field-type.search-text'])}
        />
      </SearchFieldContainer>
    );
  }
);

export default FieldTypeSearch;
